import { Injectable } from '@nestjs/common';
import {CodeListDTO} from './code-list.dto';
import {CodeList} from '../code-list.entity';
// import {CodeListStatus} from '@gtpl/shared-models/planning'
@Injectable()
export class CodeListAdapter {
  
  public convertDtoToEntity(codeListDTO: CodeListDTO,  isUpdate: boolean = false ): CodeList {
    const codeList = new CodeList();
    codeList.codeListId=codeListDTO.codeListId;
    codeList.unitId=codeListDTO.unitId;
    codeList.traceabilityCode=codeListDTO.traceabilityCode;
    codeList.CodeListStatus=codeListDTO.CodeListStatus;
    // company.isActive = statesDto.isActive == undefined ? true : statesDto.isActive;
    codeList.isActive=codeListDTO.isActive==undefined?true:codeListDTO.isActive;
    if (isUpdate) {
      codeList.updatedUser = codeListDTO.updatedUser;
    } else {
      codeList.isActive = true;
      codeList.createdUser = codeListDTO.createdUser;
    }
   return codeList;
  }
  public convertEntityToDto(codeListObject: CodeList): CodeListDTO {
    const codeListDTO= new CodeList;
    codeListDTO.codeListId=codeListObject.codeListId;
    codeListDTO.traceabilityCode=codeListObject.traceabilityCode;
    codeListDTO.unitId=codeListObject.unitId;
    codeListDTO.CodeListStatus=codeListObject.CodeListStatus;
    codeListDTO.isActive = codeListObject.isActive;
    codeListDTO.createdAt = codeListObject.createdAt;
    codeListDTO.updatedAt = codeListObject.updatedAt;
    codeListDTO.createdUser = codeListObject.createdUser;
    codeListDTO.updatedUser = codeListObject.updatedUser;
    codeListDTO.versionFlag = codeListObject.versionFlag;
    return codeListDTO;
  }
}
